import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import IndexView from '../views/IndexView.vue'
import MapView from '../views/pages/MapView.vue'
import DataView from '../views/pages/DataView.vue'
import AchiView from '../views/pages/AchiintrView.vue'
import DownloadView from '../views/pages/DownLoadView.vue'
import ItemView from '../views/pages/ItemintrView.vue'
import MethodView from '../views/pages/MethodintrView.vue'
import indexView from '../views/pages/Index.vue'
import PdfView from '../views/pages/Pdfs.vue'
import IntrView from '../views/pages/IntrView.vue'
Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    name: '/',
    redirect:'/intr/indexpage'
  },
  { 
    path: '/intr',
    name: 'intr',
    component: IntrView,
    redirect:'/intr/indexpage',
    children:[
      {
        path:'indexpage',
        name:'indexpage',
        component:indexView
      },
      {
        path:'item',
        name:'item',
        component:ItemView
      },
      {
        path:'achi',
        name:'achi',
        component:AchiView
      },
    ]
  },
  // { 
  //   path:'/indexpage',
  //   name:'indexpage',
  //   component:indexView
  // },
  // {
  //   path:'/achi',
  //   name:'achi',
  //   component:AchiView
  // },
  // {
  //   path:'/item',
  //   name:'item',
  //   component:ItemView
  // },
  {
    path:'/method',
    name:'method',
    component:MethodView
  },
  
  {
    path:'/index',
    name:'index',
    component:MapView
  },
  
  {
    path:'/download',
    name:'download',
    component:DownloadView
  },
  {
    path:'/data',
    name:'data',
    component:DataView
  },

  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path:'/pdfs',
    name:'pdf',
    component:PdfView
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局路由导航守卫：只允许/intr/indexpage访问
router.beforeEach((to, from, next) => {
  if (to.path === '/intr/indexpage') {
    next(); // 允许访问目标路由21
  } else {
    if(sessionStorage.getItem('loginStatus')=='1'){
      next();
    }else{
      
      next('/intr/indexpage'); // 重定向到允许的路径
    }

    //next('/intr/indexpage'); // 重定向到允许的路径
  }
});

export default router
